import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button
} from 'semantic-ui-react'

const ANES_ChargeItem_Tab = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardAnesBillTab">
        <Form
          id="ANES_ChargeItem_Tab-Form-20">
          <FormGroup
            id="ANES_ChargeItem_Tab-FormGroup-21"
            inline={true}
            style={{marginTop: "1rem", ...(props.isPHV && { pointerEvents: "none" })}}>
            <FormField
              id="ANES_ChargeItem_Tab-FormField-22">
              <label
                id="ANES_ChargeItem_Tab-label-26"
                style={{fontSize: "1.25rem", marginLeft: "1.5rem"}}>
                {props.languageUX === "en" ? "Expense list set" : "ชุดรายการค่าใช้จ่าย"}
              </label>
            </FormField>
            <FormField
              id="ANES_ChargeItem_Tab-FormField-23"
              style={{flex:1}}>
            </FormField>
            <FormField
              id="ANES_ChargeItem_Tab-FormField-24">
              <div
                id="ANES_ChargeItem_Tab-div-27">
                {props.buttonRefresh}
              </div>
            </FormField>
            <FormField
              id="ANES_ChargeItem_Tab-FormField-25">
              <Button
                color="blue"
                id="ANES_ChargeItem_Tab-Button-28"
                onClick={props.onSelectTemplate}>
                {props.languageUX === "en" ? "Select Template" : "เลือก Template"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <Form
          id="ANES_ChargeItem_Tab-Form-37">
          <FormGroup
            id="ANES_ChargeItem_Tab-FormGroup-38"
            inline={true}
            style={{padding : "0 15px"}}>
            <FormField
              id="ANES_ChargeItem_Tab-FormField-39"
              inline={true}
              width={6}>
              <Button
                color={props.tab === "Drug" ? "blue" : "white"}
                id="ANES_ChargeItem_Tab-Button-42"
                name="Drug"
                onClick={props.onChangeTab}
                style={{width: "100%"}}>
                {props.languageUX === "en" ? "Drug list" : "รายการยา"}
              </Button>
            </FormField>
            <FormField
              id="ANES_ChargeItem_Tab-FormField-40"
              inline={true}
              width={6}>
              <Button
                color={props.tab === "Supply" ? "blue" : "white"}
                id="ANES_ChargeItem_Tab-Button-43"
                name="Supply"
                onClick={props.onChangeTab}
                style={{width: "100%"}}>
                {props.languageUX === "en" ? "Medical Supplies List" : "รายการเวชภัณฑ์"}
              </Button>
            </FormField>
            <FormField
              id="ANES_ChargeItem_Tab-FormField-41"
              inline={true}
              style={{padding:0}}
              width={6}>
              <Button
                color={props.tab === "Operative" ? "blue" : "white"}
                id="ANES_ChargeItem_Tab-Button-44"
                name="Operative"
                onClick={props.onChangeTab}
                style={{width: "100%"}}>
                {props.languageUX === "en" ? "List of surgical procedures" : "รายการหัตถการ"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <hr
          id="ANES_ChargeItem_Tab-hr-12">
        </hr>
      </div>
    )
}


export default ANES_ChargeItem_Tab

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesBillTab"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 12,
      "name": "hr",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-hr-12"
        }
      },
      "seq": 37,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-Form-20"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormGroup",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormGroup-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\", ...(props.isPHV && { pointerEvents: \"none\" })}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormField-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormField-23"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormField-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormField-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "ชุดรายการค่าใช้จ่าย",
          "valueEN": "Expense list set"
        },
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-label-26"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.25rem\", marginLeft: \"1.5rem\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRefresh"
        },
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-div-27"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Button",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก Template",
          "valueEN": "Select Template"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-Button-28"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelectTemplate"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-Form-37"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormGroup",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormGroup-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding : \"0 15px\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormField-40"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 38,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Button",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการยา",
          "valueEN": "Drug list"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"Drug\" ? \"blue\" : \"white\""
        },
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-Button-42"
        },
        "name": {
          "type": "value",
          "value": "Drug"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Button",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการเวชภัณฑ์",
          "valueEN": "Medical Supplies List"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"Supply\" ? \"blue\" : \"white\""
        },
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-Button-43"
        },
        "name": {
          "type": "value",
          "value": "Supply"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Button",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการหัตถการ",
          "valueEN": "List of surgical procedures"
        },
        "color": {
          "type": "code",
          "value": "props.tab === \"Operative\" ? \"blue\" : \"white\""
        },
        "id": {
          "type": "value",
          "value": "ANES_ChargeItem_Tab-Button-44"
        },
        "name": {
          "type": "value",
          "value": "Operative"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeTab"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 44,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "ANES_ChargeItem_Tab",
  "project": "IsHealth_by_Front-end",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
